define('services/onlineService',[
    '../lib/knockout',
    'lib/lodash4'
], function (
    ko,
    _
) {
    'use strict';

    var isOnline = ko.observable(true);
    window.addEventListener('online', function () {
        isOnline(true);
    });
    window.addEventListener('offline', function () {
        isOnline(false);
    });

    return {
        isOnline: isOnline,
        whenOnline: function (fn) {
            window.addEventListener('online', fn);
        },
        whenOffline: function (fn) {
            window.addEventListener('offline', fn);
        },
        unsubscribe: function () {
            _.forEach(arguments, function (fn) {
                window.removeEventListener('online', fn);
                window.removeEventListener('offline', fn);
            });
        }
    };
});

